/**
 * Deployment-scoped cache env segment (not NODE_ENV).
 *
 * Staging/test/prod all run with NODE_ENV=production, so NODE_ENV cannot
 * isolate shared Upstash keys. Prefer an explicit prefix, then the deploy
 * env already wired through Compose.
 */
export function getCacheEnv(): string {
  return (
    process.env["SAJILNI_CACHE_KEY_PREFIX"]?.trim() ||
    process.env["SAJILNI_DEPLOYMENT_ENV"]?.trim() ||
    process.env["NEXT_PUBLIC_APP_ENV"]?.trim() ||
    "development"
  );
}

export function stableSerialize(
  parts: Record<string, string | undefined | null>
): string {
  const keys = Object.keys(parts).sort();
  const obj: Record<string, string> = {};
  for (const k of keys) {
    const v = parts[k];
    if (v === undefined || v === null) continue;
    obj[k] = String(v);
  }
  return JSON.stringify(obj);
}

export function buildApiCacheKey(
  scope: string,
  parts: Record<string, string | undefined | null>
): string {
  return `${scope}:${stableSerialize(parts)}`;
}

export function buildVersionedApiCacheKey(
  scope: string,
  version: string | undefined | null,
  parts: Record<string, string | undefined | null>
): string {
  const versionedScope = version ? `${scope}-v${version}` : scope;
  return buildApiCacheKey(versionedScope, parts);
}
